import { render, staticRenderFns } from "./KegiatanPelayananKB.vue?vue&type=template&id=1a175bdb"
import script from "./KegiatanPelayananKB.vue?vue&type=script&lang=js"
export * from "./KegiatanPelayananKB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a175bdb')) {
      api.createRecord('1a175bdb', component.options)
    } else {
      api.reload('1a175bdb', component.options)
    }
    module.hot.accept("./KegiatanPelayananKB.vue?vue&type=template&id=1a175bdb", function () {
      api.rerender('1a175bdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/KegiatanPelayananKB.vue"
export default component.exports